
// vue
import { defineComponent, ref } from 'vue';

// atoms
import Heading from '../atoms/Heading.vue';
import RetinaImg from '../atoms/RetinaImg.vue';

export default defineComponent({
  name: 'HowToUse',
  components: {
    Heading,
    RetinaImg,
  },
  setup() {
    const curStep = ref(0);
    const setCurStep = (num: number) => {
      curStep.value = num;
    };

    return {
      curStep,
      setCurStep,
    };
  },
});
